import { render, staticRenderFns } from "./previewMail.vue?vue&type=template&id=1da030bd&scoped=true"
import script from "./previewMail.vue?vue&type=script&lang=js"
export * from "./previewMail.vue?vue&type=script&lang=js"
import style0 from "./previewMail.vue?vue&type=style&index=0&id=1da030bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da030bd",
  null
  
)

export default component.exports